import { render, staticRenderFns } from "./updatePartnerSummary.vue?vue&type=template&id=1961ff42&scoped=true"
import script from "./updatePartnerSummary.vue?vue&type=script&lang=js"
export * from "./updatePartnerSummary.vue?vue&type=script&lang=js"
import style0 from "./updatePartnerSummary.vue?vue&type=style&index=0&id=1961ff42&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1961ff42",
  null
  
)

export default component.exports